import { useEffect, useState } from 'react';
import Api from 'services/api';

const LOWERCASE = ['de', 'da', 'do', 'das', 'dos', 'e'];

const titleCase = (text: string) =>
  text
    .toLowerCase()
    .split(/\s+/)
    .map((word, index) =>
      index > 0 && LOWERCASE.includes(word) ? word : word.charAt(0).toUpperCase() + word.slice(1),
    )
    .join(' ');

export function useCompanyLocation(cnpj: string) {
  const [location, setLocation] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    setLocation(null);

    Api.get('/mercado/company', { params: { cnpj } })
      .then(({ data }) => {
        const empresa = data?.data?.empresa;
        const city = empresa?.municipio ? titleCase(String(empresa.municipio)) : null;
        const value = [city, empresa?.uf?.toUpperCase()].filter(Boolean).join(' - ');
        if (active) setLocation(value || null);
      })
      .catch(() => undefined);

    return () => {
      active = false;
    };
  }, [cnpj]);

  return location;
}
